// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-art-js": () => import("./../../../src/pages/Art.js" /* webpackChunkName: "component---src-pages-art-js" */),
  "component---src-pages-gamedev-js": () => import("./../../../src/pages/gamedev.js" /* webpackChunkName: "component---src-pages-gamedev-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-webdev-js": () => import("./../../../src/pages/webdev.js" /* webpackChunkName: "component---src-pages-webdev-js" */)
}

